import React from 'react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
import { Star, CheckCircle2, CreditCard } from 'lucide-react';
export function Hero() {
  return <>
      {/* Top trust bar */}
      <div className="bg-zinc-950 border-b border-brand-green/30 text-white py-2 px-3 text-center" data-id="element-100">
        <div className="max-w-5xl mx-auto flex flex-wrap items-center justify-center gap-1.5 md:gap-2.5 text-[11px] md:text-sm font-semibold" data-id="element-101">
          <div className="flex text-brand-yellow" data-id="element-102">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 md:w-4 md:h-4 fill-current" data-id="element-103" />)}
          </div>
          <span className="text-white" data-id="element-104">
            <span className="text-brand-greenLight font-black" data-id="element-105">+2.300</span>{' '}
            Productores Ganaderos y Trabajadores Rurales ya usan este sistema
          </span>
        </div>
      </div>

      {/* Hero section */}
      <section className="bg-gradient-to-b from-zinc-950 to-black pt-5 pb-7 md:pt-8 md:pb-10 px-4 relative overflow-hidden" data-id="element-106">
        <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-107">
          <h1 className="text-xl md:text-3xl lg:text-4xl font-display font-bold mb-3 leading-[1.1] text-white uppercase text-shadow-bold" data-id="element-108">
            Dejá de Improvisar Corrales que Te Hacen{' '}
            <span className="highlight-green" data-id="element-109">
              Perder Tiempo y Productividad
            </span>
          </h1>

          <p className="text-sm md:text-base text-zinc-300 mb-2 max-w-2xl mx-auto font-semibold" data-id="element-110">
            Todo lo que necesitás para mejorar el manejo ganadero está acá, en
            un solo sistema profesional.
          </p>

          <p className="text-xs md:text-sm text-zinc-400 mb-5 max-w-2xl mx-auto" data-id="element-111">
            <span className="font-bold text-white" data-id="element-112">75 diseños funcionales</span>
            , circulación inteligente y configuraciones pensadas para trabajar
            mejor todos los días.
          </p>

          {/* Hero image */}
          <div className="w-full max-w-md mx-auto mb-5 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300" onClick={scrollToCompra} data-id="element-113">
            <img src="https://cdn.magicpatterns.com/uploads/v8R397hRbK2p4dp3u2sdaG/corrales_ganaderos_.png" alt="Sistema Pro Corrales Ganaderos - 75 Diseños Profesionales" className="w-full h-auto drop-shadow-2xl" data-id="element-114" />
          </div>

          <div className="max-w-md mx-auto mb-3" data-id="element-115">
            <Button data-id="element-116">🚀 QUIERO EL SISTEMA PRO CORRALES</Button>
          </div>

          {/* Mercado Pago badge */}
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-117">
            <div className="inline-flex items-center gap-2 bg-zinc-900 border border-brand-green/40 px-3 py-1.5 rounded-full" data-id="element-118">
              <CreditCard className="w-3.5 h-3.5 text-brand-greenLight" data-id="element-119" />
              <span className="text-[11px] md:text-xs font-bold text-white" data-id="element-120">
                Pagás con
              </span>
              <span className="text-[11px] md:text-xs font-black bg-[#00b1ea] text-white px-2 py-0.5 rounded" data-id="element-121">
                Mercado Pago
              </span>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-xs md:text-sm text-zinc-300 font-semibold" data-id="element-122">
            <div className="flex items-center gap-1" data-id="element-123">
              <CheckCircle2 className="w-4 h-4 text-brand-greenLight" data-id="element-124" />
              <span data-id="element-125">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-126">
              <CheckCircle2 className="w-4 h-4 text-brand-greenLight" data-id="element-127" />
              <span data-id="element-128">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-129">
              <CheckCircle2 className="w-4 h-4 text-brand-greenLight" data-id="element-130" />
              <span data-id="element-131">Pago único</span>
            </div>
          </div>
        </div>
      </section>
    </>;
}